import { render, staticRenderFns } from "./run-cognitive-test.vue?vue&type=template&id=003775fc&v-if=testComponent&"
import script from "./run-cognitive-test.vue?vue&type=script&lang=ts&"
export * from "./run-cognitive-test.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports